import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { get } from '@core/interceptors/fetch-client';
import { ApiUtils } from '@core/services/Utils/apiUtils';
import { BehaviorSubject } from 'rxjs';
import { GroupRoasterResponse, Organization } from '@interface/groupRoaster';

@Injectable({
  providedIn: 'root',
})
export class GroupRosterService {
  private organizationDetails = new BehaviorSubject<Organization | undefined>(
    undefined,
  );
  private groupRoasterData = new BehaviorSubject<
    GroupRoasterResponse | undefined
  >(undefined);

  constructor() {}
  organizationDetails$ = this.organizationDetails.asObservable();
  groupRoasterData$ = this.groupRoasterData.asObservable();

  async fetchGroupRosterData(): Promise<any> {
    let response = null;
    const url = `${environment.getGroupRosterData}`;
    await ApiUtils.handleApiResponse1(
      get<GroupRoasterResponse>(url),
      (data, statusCode) => {
        if (statusCode === 200) {
          this.updateGroupRoasterDetails(data!);
        }
        response = { data, statusCode };
      },
      'Failed to fetch group roaster data:',
    );
    return response;
  }

  async getOrganizationData(): Promise<any> {
    let response = null;
    const url = `${environment.getOrganization}`;
    await ApiUtils.handleApiResponse1(
      get<any>(url),
      (data, statusCode) => {
        if (statusCode === 200) {
          this.updateOrganizationDetails(data.data);
        }
        response = { data, statusCode };
      },
      'Failed to fetch organization data:',
    );
    return response;
  }

  updateOrganizationDetails(val: Organization): void {
    this.organizationDetails.next({ ...val });
  }

  private updateGroupRoasterDetails(data: GroupRoasterResponse): void {
    this.groupRoasterData.next(data);
  }
}
